var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankDefaultIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_7078_17028)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#619BF3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7078_17028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7693 14.8334L21.2309 14.8334C21.8259 14.8334 22.0596 14.045 21.5645 13.7079L16.6673 10.373C16.2633 10.0979 15.7369 10.0979 15.3329 10.373L10.4357 13.7079C9.94055 14.045 10.1742 14.8334 10.7693 14.8334Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3333,
    y: 14.8333,
    width: 2.91667,
    height: 4.66667,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 14.8333,
    width: 2.91667,
    height: 4.66667,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0486 19.5C20.4273 19.5 20.7736 19.714 20.943 20.0528L21.1096 20.3861C21.4421 21.051 20.9586 21.8333 20.2152 21.8333L11.7846 21.8333C11.0412 21.8333 10.5577 21.051 10.8902 20.3861L11.0569 20.0528C11.2263 19.714 11.5725 19.5 11.9513 19.5L20.0486 19.5Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_7078_17028",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7078_17028"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7078_17028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankDefaultIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bank-default-icon.b61fe69f881b95be0da95ae932549cdd.svg";